import React, { useEffect, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";

import ErrorBoundary from "../hoc/ErrorBoundary.js";
import { ToastProvider } from "../contexts/ToastContext";

import { withRouter } from "../shared/utility";
import DefaultLayout from "../components/layouts/DefaultLayout";
import Login from "../views/authentication/Login";

function App(props) {
  const { autchCheckCart, authCheckOrderDetails, authCheckState, business } =
    props;

  useEffect(() => {
    authCheckState();
  }, [authCheckState]);

  useEffect(() => {
    autchCheckCart();
  }, [autchCheckCart]);

  useEffect(() => {
    authCheckOrderDetails();
  }, [authCheckOrderDetails]);

  let routes = null;

  const authToken = localStorage.getItem("authToken");

  let authRedirect = null;
  if (authToken) {
    if (props.isAuthenticated) {
      routes = (
        <Routes>
          <Route path="*" element={<DefaultLayout business={business} />} />
        </Routes>
      );
    }
  } else {
    routes = (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <ToastProvider>
      <div className="h-full">
        {authRedirect}
        <ErrorBoundary>
          <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
        </ErrorBoundary>
      </div>
    </ToastProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.authToken !== null,
    business: state.auth.business,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(actions.authCheckState()),
    autchCheckCart: () => dispatch(actions.autchCheckCart()),
    authCheckOrderDetails: () => dispatch(actions.authCheckOrderDetails()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
